export function init () {
  cube.storage.remove('giftcardFormData'); // (remove giftcard form info in local Storage)
}



// WEBPACK FOOTER //
// ./src/checkout/confirmation/confirmation.js